import { observer } from 'mobx-react-lite';
import { useStoreByName } from '@web/hooks/use-stores.hooks';
import VoiceLevelMeter from './VoiceLevelMeter';

/**
 * נורת המיקרופון של האפליקציה.
 * צהוב: הפסוק מוצג והמיקרופון כבר פתוח ומוכן, אבל עוד לא לחצו ושום צליל לא נשלח.
 * ירוק: מרגע הלחיצה, וכל זמן הקריאה.
 * כבוי: המיקרופון סגור.
 * את נורת ההקלטה של הדפדפן עצמו אי אפשר לצבוע, היא נדלקת בכל פעם שהמיקרופון פתוח.
 */
const MicIndicator: React.FC = observer(() => {
    const speechRecognitionStore = useStoreByName('speechRecognitionStore') as any;
    const { isListening, isInitializing, isMicrophonePrepared } = speechRecognitionStore;

    // ירוק ברגע הלחיצה, בלי צהוב באמצע: גם בזמן ההכנה שאחרי הלחיצה הנורה כבר ירוקה
    const state = isListening || isInitializing ? 'on' : isMicrophonePrepared ? 'ready' : 'off';

    // מד העוצמה יושב ליד הנורה ולא בתוכה, כדי שלא יהבהב יחד איתה.
    // הוא מופיע רק בזמן הקשבה, ולכן לא נראה על תג הכפתור בתצוגה המקדימה.
    return (
        <>
        <div className={`mic-indicator ${state}`} role="img" aria-label="מיקרופון">
            <svg viewBox="0 0 68 68" aria-hidden="true">
                <circle className="mic-indicator__dot" cx="34" cy="34" r="34" />
                <path
                    fill="white"
                    d="M33.5 43.5C38.4706 43.5 42.5 39.4706 42.5 34.5V19.5C42.5 14.5294 38.4706 10.5 33.5 10.5C28.5294 10.5 24.5 14.5294 24.5 19.5V34.5C24.5 39.4706 28.5294 43.5 33.5 43.5ZM48.5 28.5H47C46.1712 28.5 45.5 29.1712 45.5 30V34.5C45.5 41.5125 39.4541 47.1394 32.3009 46.4419C26.0666 45.8334 21.5 40.2291 21.5 33.9656V30C21.5 29.1712 20.8288 28.5 20 28.5H18.5C17.6712 28.5 17 29.1712 17 30V33.765C17 42.1688 22.9972 49.6603 31.25 50.7984V54H26C25.1713 54 24.5 54.6712 24.5 55.5V57C24.5 57.8288 25.1713 58.5 26 58.5H41C41.8288 58.5 42.5 57.8288 42.5 57V55.5C42.5 54.6712 41.8288 54 41 54H35.75V50.8341C43.7853 49.7316 50 42.8344 50 34.5V30C50 29.1712 49.3288 28.5 48.5 28.5Z"
                />
            </svg>
        </div>
        <VoiceLevelMeter />
        </>
    );
});

export default MicIndicator;
